export const unitTypeSelect = [
  {
    value: 'PORTATIL',
    label: 'PORTATIL'
  },
  {
    value: 'ESTACIONARIO',
    label: 'ESTACIONARIO'
  },
  {
    value: 'ESTACION',
    label: 'ESTACION'
  },
]